import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import { Icon } from 'react-icons-kit'
import NavBar from '../components/NavBar'
import FrTextInput from '../components/FrTextInput'
import FrSelect from '../components/FrSelect'
import UserOptions from '../components/UserOptions'
import FrLoading from '../components/FrLoading'
import FrTableReg from '../components/FrTableReg'
import { ic_add_box } from 'react-icons-kit/md/ic_add_box'

import api from '../services/api'
import { paramsToObject, validarCPF, asyncForEach } from '../utils/functions'
import { mCPF, mTel } from '../utils/masks'

import './styles/DefaultReg.css';
import FooterDelphus from '../components/FooterDelphus';
import $ from 'jquery'

const swal = withReactContent(Swal)

function Propostas() {
  const [auth, setAuth] = useState(JSON.parse(localStorage['authKSA'] || JSON.stringify({ authenticated: false, user: 0 })));
  const [data, setData] = useState({})
  const [erroCpf, setErroCpf] = useState(false)
  const [updateType, setUpdateType] = useState(false)
  const [erroEmail, setErroEmail] = useState(false)
  const [fk_prp, setFk_prp] = useState(0)

  const columnsArq = [{ id: 'nome', numeric: false, label: 'Nome', align: 'left', minWidth: 400 },
  { id: 'descricao', numeric: false, label: 'Tipo Documento', align: 'left', minWidth: 400 },
  ]

  const [arq_Codigo, setArq_Codigo] = useState('')
  const [arq_Nome, setArq_Nome] = useState('')
  const [comboTdc, setComboTdc] = useState([{ value: '', display: '' }])
  const [dataArq, setDataArq] = useState([{ pk: "", nome: "", descricao:"", codigo: "", fk_prp: fk_prp}])
  const [modal, setModal] = useState(false)
  const [updatemodal, setUpdateModal] = useState(false)
  const [pkModal, setPkModal] = useState(0)
  let formData = new FormData();
  const [file, setFile] = useState('');

  useEffect(() => {

    const fetchData = async () => {
      swal.fire({
        html: <FrLoading text="Carregando..." />,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })
      const urlParams = new URLSearchParams(window.location.search);
      let query = paramsToObject(urlParams)
      setFk_prp(query.codigo)

      setComboTdc(await api.getComboData('tipo_documento'))

  
      if (query.codigo) {
        setUpdateType(true)

        api.get('/propostas/arquivos?fk_prp=' + query.codigo).then(r => {

          if (r.data[0]) {

            const auxValues = [...r.data]
            const auxArq = [...dataArq]
            asyncForEach(auxValues, async function(element, index) {

              let auxText = String(element.URL).split("/");

              api.get('/tipo_documento/?pk_tdc=' + element.FK_TDC).then(r => {
                auxValues[index].arq_Nome = auxText[auxText.length-1];
                auxArq.push({pk: element.PK_PDO, nome: auxText[auxText.length-1], descricao:r.data[0].DESCRICAO, codigo:r.data[0].PK_TDC, fk_prp: query.codigo})
         
                if (index == auxValues.length-1){
  
                  let filterArq = auxArq.filter((element)=>{
                    return element.pk != ''
                  })
  
                  setData(auxValues)
                  setDataArq(filterArq)
                  swal.close()
                }
              })
                
            })
          
          } else {
            // swal.fire('Código inválido', 'Código informado não encontrado!', 'warning')
            //   .then((result) => {
            //     if (result.value) {
            //       window.history.back()
            //     }
            //   })
            swal.close()
          }
        })
      } else swal.close()
    }

    fetchData()
  }, [])

  function consistData(data) {
    let required = [
    ]

    let errors = []

    required.forEach((curr, index) => {
      let fieldName = curr
      if (!data[curr]) return errors.push(fieldName)

      // if (erroEmail && (errors.indexOf('EMAIL') === -1)) errors.push('EMAIL')

    })

    return errors
  }


  function handleSubmit(e) {
    e.preventDefault();
    swal.fire({
      title: 'ATENÇÃO',
      text: "Deseja salvar " + (updateType ? 'as alterações' : 'a inclusão') + ' do registro?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then((result) => {
      if (result.value) {
        const auxValues = { ...data };        
        
        auxValues.host = window.location.href;
        auxValues.pk_uex = auth.user;
        auxValues.dataArq = dataArq;

        try {
          formData.append('files', auxValues.dataArq)
        } catch {

        }
        auxValues.fk_prp = fk_prp
        formData.append('data', JSON.stringify(auxValues))
        let errors = consistData(auxValues)
        console.log(errors.length)
        if (errors.length === 0) {
          if (updateType) {
            api.post('/propostas/addArquivos', formData).then(r => {
              if (r.status === 200) {
                swal.fire({
                  title: 'Registro Alterado',
                  text: "O registro foi alterado com sucesso!",
                  icon: 'success',
                }).then((result) => {
                  if (result.value) {
                    window.history.back()
                  }
                })
              } else {
                swal.fire({
                  title: 'Erro!',
                  text: "O registro não foi alterado!",
                  icon: 'warning',
                })
              }
            })
          } else {
           
                swal.fire({
                  title: 'Erro!',
                  text: "O registro não deve ser adicionado!",
                  icon: 'warning',
                })
              

          }
        } else {
          swal.fire({
            title: 'Erro!',
            text: "Verifique o(s) campo(s) " + errors.join(','),
            icon: 'warning',
          })
        }
      }
    })
  }

  function handleCancel(e) {
    e.preventDefault();
    swal.fire({
      title: 'ATENÇÃO',
      text: "Caso cancele a alteração/inclusão, todos os dados digitados serão perdidos. Confirma?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then((result) => {
      if (result.value) {
        window.history.back()
      }
    })
  }

  const handleChange = (e) => {
    const auxValues = { ...data };
    // auxValues[e.target.name] = e.target.value;
    switch (e.target.name) {
      

      default: auxValues[e.target.name] = e.target.value;
    }
    setData(auxValues);
  };


  function mostraModal(e) {
    e.preventDefault()

    setArq_Nome('')
    setUpdateModal(false)
    setModal(true)
  }

  useEffect(()=>{
    let auxValues = { ...data }
    if (file) {
       
          auxValues.arq_c = file
          setArq_Nome(file.name)
          // formData.append('file', file)
          // setFormData({'files':[...formData.files], file})
          console.log(arq_Nome)
        
    } else {
        auxValues.arq = null
        auxValues.receita = 'Nenhum arquivo selecionado'
    }
    setData(auxValues)
  }, [file])

  const handleSelectedFile = (e) => {
    setFile(e.target.files[0]);
    console.log(file, e.target)
  }

  const handleChangeModal = (e) => {
    if (e.target.name == 'arqFk_tdc') {
      setArq_Codigo(e.target.value)
      console.log(e.target.text)
    }
  }

  const selectFile = (e) => {
    e.preventDefault();
    console.log(e.target)

      $('#html_btn_1').click();

    
  } 

  function closeModal(e) {
    e.preventDefault()
    setModal(false)
  }

  async function handleSubmitModalResidente(e) {
    e.preventDefault()
    console.log(file.name)
    let formData = new FormData();
    if (arq_Nome) {
      console.log('teste 2 vez')
      if (!updatemodal){
        incluiArq(e)
      }
      else{
        updateArq(e)
      }
      console.log('teste de um upload de arquivo normal com muita linha escrita pra achar no log do browser')
      try {
      formData.append('file_arq', file, arq_Nome)
    } catch {

      }
      // formData.append('data', {id: fk_prp})
      api.post('/proposta/uploadArquivo?fk_prp='+fk_prp, formData).then(r => {
        if (r.status === 200) {
          swal.fire({
            html: <FrLoading text="Carregando..." />,
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false
          }).then(()=>{
            swal.close()
          })

        }
      })
      // carregaArquivo(e)
      closeModal(e)
        
    } else
      swal.fire({
        title: 'Erro!',
        text: "Informe Arquivo!",
        icon: 'warning',
      })
  }



  async function incluiArq(e) {
    e.preventDefault();
    let pk = 1
    let nome = arq_Nome
    let descricao = ''

    await api.get('/tipo_documento?pk_tdc=' + arq_Codigo).then(r => {
      if (r.data.length > 0)
        console.log(r.data[0])
        descricao = (r.data[0].DESCRICAO)
    })

    console.log(descricao)
    if (!dataArq[0].pk) {
      console.log(dataArq[0].pk)
      setDataArq([{
        nome: nome,
        codigo: arq_Codigo,
        descricao: descricao,
        pk: pk
      }])
      console.log(dataArq)

    } else {

      let item = [{

        nome: dataArq[0].nome,
        codigo: dataArq[0].arq_Codigo,
        descricao: dataArq[0].descricao,
        pk: pk

      }]
      pk++
      var i;
      for (i = 1; i < dataArq.length; i++) {
        item.push({

          nome: dataArq[i].nome,
          codigo: dataArq[i].arq_Codigo,
          descricao: dataArq[i].descricao,
          pk: pk

        })
        pk++
      }
      item.push({

        nome: nome,
        codigo: arq_Codigo,
        descricao: descricao,
        pk: pk
      })
      pk++
      setDataArq(item)

    }


  }

  async function updateArq(e) {
    e.preventDefault();

    let item = []
    let nomeArq = ''
    let i
    let descricao = ''

    await api.get('/tipo_documento?pk_tdc=' + arq_Codigo).then(r => {
      if (r.data.length > 0)
        descricao = (r.data[0].DESCRICAO)
    })
    console.log(descricao)

    for (i = 0; i < dataArq.length; i++) {
      if (dataArq[i].pk == pkModal) {
        item.push({

          nome: arq_Nome,
          codigo: arq_Codigo,
          descricao: descricao,
          pk: pkModal,
        })
      } else {
        item.push({

          nome: dataArq[i].arq_Nome,
          codigo: dataArq[i].arq_Codigo,
          descricao: dataArq[i].descricao,
          pk: dataArq[i].pk,
        })
      }

      if (i + 1 == dataArq.length)
        setDataArq(item)
    }
  }


  return (
    <div className="defaultReg">
      <NavBar />
      <div className="defaultRegContent">
        <div className="defaultHeader">
          <h1>{updateType ? 'Edição' : 'Inclusão'} de Proposta</h1>
          <UserOptions />
        </div>
        <br />
        <form id="regForm" onSubmit={handleSubmit}>
          {/* <Paper elevation={1} square> */}
          <div className="paperDiv" >
            {/* <h2>Dados do Proponente:</h2> */}
            
            <button onClick={(e) => mostraModal(e)} style={{marginBottom: '10px'}}>
              <Icon icon={ic_add_box} size={18} />
              Incluir
            </button>

            <div className="manutReg">
              <FrTableReg
                setPkModal={setPkModal}
                setUpdateModal={setUpdateModal}
                setModal={setModal}
                setArq_Codigo={setArq_Codigo}
                setArq_Nome={setArq_Nome}
                editar={true}
                setDataGrid={setDataArq}
                detail
                regName="propostaAssociado"
                columns={columnsArq}
                searched={false}
                codeName="fk_prp"
                page={""}
                data={dataArq}
                download={true}
              />

              <div className="register" hidden={!modal}>
                {/* <div className="register" hidden={false}> */}
                <div className="fields">
                  <FrSelect
                    value={arq_Codigo || ''}
                    onChange={handleChangeModal}
                    name="arqFk_tdc"
                    id="arqFk_tdc"
                    label='Tipo Documento'
                    data={comboTdc}
                    style={{ width: 400 }}
                  />
                  <input
                    type="file"
                    name="arquivo_nome"
                    id="html_btn_1"
                    accept=".pdf"
                    onChange={handleSelectedFile}
                    display={false}
                    hidden
                  />

                  <FrTextInput
                    value={arq_Nome || ''}
                    onChange={handleSelectedFile}
                    onClick={selectFile}
                    name="arquivo_nome"
                    id="arquivo_nome"
                    color="#528b46"
                    label="Arquivo"
                    variant="outlined"
                    size="small"
                    disabled
                    style={{ width: 294 }}
                  // onClick={handleClick}
                  />
                  {auth.residente > 0 ? <></> :
                  <button type="file" className="incluiFileButton" onClick={selectFile} id='arq_c'>
                    Upload
                  </button>
                  }
                  <br/>
                  
                </div>
                <div className="regButtonsDiv">
                  <button onClick={handleSubmitModalResidente}>
                    Salvar
                  </button>
                  <button onClick={closeModal}>Cancelar</button>
                </div>
              </div>    
              {/* <div className="regButtonsDiv">
                <button style={{ display: updateType ? 'none' : 'block' }} onClick={handleSubmit}>Salvar</button>

              </div> */}
            
            </div>
          
            {/* </Paper> */}

    
          </div>

          <br />

        </form>
        <div className="regButtonsDiv">
        <button onClick={handleSubmit}>Salvar</button>
          <button onClick={handleCancel}>Cancelar</button>
        </div>
        <FooterDelphus />
      </div>
    </div>
  );
}

export default Propostas;
